import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { hotTags } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20with%20abstract%20geometric%20shapes%20and%20warm%20amber%20gold%20accents%20on%20deep%20charcoal%20background%2C%20luxurious%20velvet%20texture%2C%20mysterious%20atmosphere%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20elegant%20dark%20aesthetic%2C%20no%20people&width=1920&height=1080&seq=hero-bg-911-2026&orientation=landscape"
        alt="911爆料网 - 吃瓜黑料第一站"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="911爆料网 - 吃瓜黑料第一站"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center w-full max-w-3xl mx-auto" style={{ marginTop: '-2%' }}>
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/30 text-background-50 text-xs md:text-sm font-medium mb-5 md:mb-7 backdrop-blur-sm">
            全网黑料 · 实时更新
          </span>
          <h1 className="text-3xl md:text-6xl lg:text-7xl font-bold font-heading text-background-50 leading-tight mb-4 md:mb-6">
            <span className="block">{siteInfo.tagline}</span>
            <span className="block text-accent-400">吃瓜不等待</span>
          </h1>
          <p className="text-sm md:text-base text-background-50/70 max-w-lg mx-auto mb-6 md:mb-8 leading-relaxed">
            每日实时更新网红翻车、明星八卦、反差视频等热门大瓜，免费在线看最新黑料
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
            {hotTags.map((tag) => (
              <Link
                key={tag}
                to={`/category/wanghong-fanche`}
                className="px-3 md:px-4 py-1.5 rounded-full text-xs md:text-sm bg-background-50/10 text-background-50/80 hover:bg-background-50/20 hover:text-background-50 backdrop-blur-sm transition-all duration-200 whitespace-nowrap"
              >
                #{tag}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}